/** Serializable orientation data. Shared state must not import the 3D engine. */
export interface BloomTurn { x: number; y: number; z: number; w: number }
export const BLOOM_HOME: Readonly<BloomTurn> = { x: 0, y: 0, z: 0, w: 1 };
